import React from "react";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import { useApiClient } from "@/hooks/useApiClient";
import { getAttachedFileNameFromHeader } from "@/utils/utils";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import { HttpStatusCode, isAxiosError } from "axios";
import { READ_ONLY_TOOLTIP_MESSAGE } from "@/utils/permissions";
import * as Sentry from "@sentry/react";

interface OutputMenuProps {
  disabled: boolean;
  requestId: number;
  isReadOnly?: boolean;
  onDownloadComplete?: () => void;
}

export default function OutputMenu({
  disabled,
  requestId,
  isReadOnly = false,
  onDownloadComplete,
}: OutputMenuProps): React.ReactElement {
  const { apiClient } = useApiClient();

  const onDownloadFile = async (fallBackName: string): Promise<void> => {
    if (isReadOnly) {
      toast.error(READ_ONLY_TOOLTIP_MESSAGE);
      return;
    }
    try {
      const res = await apiClient.get(
        `/commercial-picture-analyze/download-file/${requestId}`,
        {
          responseType: "blob",
        }
      );
      const filename = getAttachedFileNameFromHeader(res, fallBackName);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      fileDownload(res.data, filename);
      onDownloadComplete?.();
    } catch (e) {
      if (isAxiosError(e) && e.response?.status === HttpStatusCode.Forbidden) {
        toast.error(READ_ONLY_TOOLTIP_MESSAGE);
        throw e;
      }
      Sentry.captureException(e);
      toast.error("ファイルのダウンロードに失敗しました");
      throw e;
    }
  };

  return (
    <Button
      disabled={disabled}
      variant="outlined"
      color="primary"
      onClick={() => {
        void onDownloadFile(`商業登記解析結果_${requestId}.xlsx`).catch(
          () => undefined
        );
      }}
    >
      エクセル出力
      <DownloadIcon />
    </Button>
  );
}
